module.exports = __webpack_public_path__ + "static/media/privacy-policy-production.6f7310b8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/privacy-policy-production.pdf
// module id = 655
// module chunks = 0